import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { BadgeRoot } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/components/DocumentStatusBadge/StyledComponents';
import type { DocumentStatusVariant } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/components/DocumentStatusBadge/types';

type Props = {
  variant: DocumentStatusVariant;
};

const LABEL_BY_VARIANT: Record<DocumentStatusVariant, { id: string; defaultMessage: string }> = {
  paid: { id: 'documents.item.badge.paid', defaultMessage: 'Paid' },
  paymentPreparation: {
    id: 'documents.item.badge.sentToPaymentPreparation',
    defaultMessage: 'Submitted for payment processing',
  },
};

const DocumentStatusBadge: React.FC<Props> = ({ variant }) => {
  const label = LABEL_BY_VARIANT[variant];

  return (
    <BadgeRoot variant={variant}>
      <FormattedMessage id={label.id} defaultMessage={label.defaultMessage} />
    </BadgeRoot>
  );
};

export default memo(DocumentStatusBadge);
